import React from "react";
import AboutSection from "../components/pages/index/AboutSection";
import ProjectSections from "../components/pages/index/ProjectSections";
import PastProjectSection from "../components/pages/index/PastProjectsSection";
import { HomeFooter } from "../components/common/Footer";

const IndexPage = () => {
	return [
		<AboutSection key="about" />,
		<ProjectSections key="mainProjects" />,
		<PastProjectSection key="pastProjects" />,
		<HomeFooter key="homeFooter" />,
	];
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js